import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'
import Type from 'components/Type'
import Icon from 'components/Icon'
import Label from 'components/Label'
import { STATES, STATES_WITH_DC } from 'utils/formOptions'

const StateSelect = ({
  onChange, 
  startingValue, 
  autocompleteProps, 
  textfieldProps,
  noLabel,
  filter,
  addDC,
  lock,
}) => {
  const [open, setOpen] = useState(false)
  const [value, setValue] = useState(null)
  const allStates = addDC ? STATES_WITH_DC : STATES
  const filteredOptions = filter ? allStates.filter(filter) : allStates

  useEffect(() => {
    if (startingValue) setValue(startingValue)
  }, [startingValue])

  return (
    <Stack
      gap={1}
    >
      {!noLabel && (
        <Label>
          State
        </Label>
      )}
      <Autocomplete
        open={open}
        className="outlined"
        options={filteredOptions}
        disabled={lock}
        autoHighlight
        autoSelect
        getOptionLabel={option => option}
        renderOption={(props, option) => (
          <div {...props}>
            <Type
              variant="dataSmall"
            >
              {option}
            </Type>
          </div>
        )}
        autoComplete
        openOnFocus
        sx={theme => ({
          '.Mui-disabled': {
            WebkitTextFillColor: theme.palette.text.neutralCool_700,
          },
        })}
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue)
          if (!!onChange) onChange(newValue, filteredOptions.includes(newValue))
        }}
        onInputChange={(event, newInputValue) => {
          if (filteredOptions.includes(newInputValue) && !!onChange) {
            setValue(newInputValue)
            onChange(newInputValue, filteredOptions.includes(newInputValue))
          }
        }}
        onOpen={e => {
          if (e.type !== 'change') setOpen(true)
        }}
        onClose={() => setOpen(false)}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="––"
            variant="filled"
            inputProps={{
              ...params.inputProps,
              type: 'search',
              autoComplete: 'address-level1',
              ...(lock ? {
                endAdornment: <Box height="25px" width="20px" mr={1}><Icon icon="Lock" /></Box>,
                readOnly: true,
              } : {}),
            }}
            {...textfieldProps}
          />
        )}
        {...autocompleteProps}
      />
    </Stack>
  )
}

StateSelect.propTypes = {
  autocompleteProps: PropTypes.object,
  textfieldProps: PropTypes.object,
  startingValue: PropTypes.object,
  onChange: PropTypes.func,
  noLabel: PropTypes.bool,
  filter: PropTypes.func,
  addDC: PropTypes.bool,
  lock: PropTypes.bool,
}

StateSelect.defaultProps = {
  variant: 'default',
  autocompleteProps: {},
}

export default StateSelect